export const Y1731ConfigFieldMapping = {
  //setup
  ALIAS: 'alias',
  CUSTOMER: 'customer',
  CONTACT: 'contact',
  EMAIL: 'email',
  PHONE: 'phone',
  TECHINICIAN: 'technician',
  TECHINICIANID: 'technicianId',
  COMMENTS: 'comments',
  TEST_TYPE: 'testType',
  RUN_TYPE: 'runType',
  AGENT_TYPE: 'agentType',
  SELECTED_ORIGINATOR: 'selectedOriginator',
  SELECTED_DESTINATION: 'selectedDestination',
  SCHEDULER: 'scheduler',
  SRC_MAC_ADDRESS: 'source-mac',
  MEP_ID: 'mep-id',
  PM_REPORT_INTERVAL: 'pm-report-interval',
  PERSIST_AFTER_REBOOT: 'persist-after-reboot',
  VLAN_CONFIG: 'vlanConfig',
  SVLAN_ID: 'vlan-id',
  SVLAN_PRIORITY: 'vlan-priority',
  CVLAN_ID: 'inner-vlan-id',
  CVLAN_PRIORITY: 'inner-vlan-priority',
  CVLAN_ETHER_TYPE: 'tpid',
  FLOWS: 'flows',
  FLOW_ID: 'flowId',
  DESTINATION_MAC: 'destinationMac',
  MEG_LEVEL: 'megLevel',
  MEG_ID: 'megId',
  ATTRIBUTES: 'attributes',
  PM: 'pm',
  CCM: 'ccm'
};
export const REPORT_INTERVAL_TYPES = [
  { name: '1 minute', value: 60 },
  { name: '5 minute', value: 300 },
  { name: '15 minute', value: 900 }
];
export const CONFIRM_SELECTION = [
  { name: 'Yes', value: true },
  { name: 'No', value: false }
];
export enum vlanConfigLabel {
  UNTAGGED = 'Untagged',
  SINGLE_VLAN = 'Single VLAN',
  Q_IN_Q = 'Q-in-Q'
}

export enum vlanConfigValue {
  UNTAGGED = 'untagged',
  SINGLE_VLAN = 'tagged',
  Q_IN_Q = 'q_in_q'
}

export enum ETHER_TYPE_LABEL {
  ETHER_8100 = '8100',
  ETHER_88a8 = '88a8',
  ETHER_9100 = '9100'
}

export const VLAN_CONFIG_TYPE = [
  { name: vlanConfigLabel.UNTAGGED, value: vlanConfigValue.UNTAGGED },
  { name: vlanConfigLabel.SINGLE_VLAN, value: vlanConfigValue.SINGLE_VLAN },
  { name: vlanConfigLabel.Q_IN_Q, value: vlanConfigValue.Q_IN_Q }
];

export const ETHER_TYPE = [
  { name: '8100', value: ETHER_TYPE_LABEL.ETHER_8100 },
  { name: '88a8', value: ETHER_TYPE_LABEL.ETHER_88a8 },
  { name: '9100', value: ETHER_TYPE_LABEL.ETHER_9100 }
];

export const SLM_PERIOD_TYPES = [
  { name: 'off', value: 'off' },
  { name: '10ms', value: '10ms' },
  { name: '100ms', value: '100ms' },
  { name: '1s', value: '1s' }
];

export const DMM_PERIOD_TYPES = [
  { name: '10ms', value: '10ms' },
  { name: '100ms', value: '100ms' },
  { name: '1s', value: '1s' }
];

export const CCM_PERIOD_TYPES = [
  { name: 'off', value: 'off' },
  { name: '100ms', value: '100ms' },
  { name: '1s', value: '1s' },
  { name: '10s', value: '10s' }
];

export const MEG_ID_FORMAT_TYPES = [
  { name: '1 - Primary VID', value: 1 },
  { name: '2 - string', value: 2 },
  { name: '3 - 2 octet integer', value: 3 },
  { name: '4 - VPN ID', value: 4 },
  { name: '32 - ICC', value: 32 }
];

export const STANDARD_TYPES = [
  { name: 'ITU', value: 'ITU' },
  { name: 'IEEE', value: 'IEEE' }
];

export const MD_NAME_FORMAT_TYPES = [
  { name: '2 - Domain Name', value: 2 },
  { name: '3 - MAC address + 2 octet integer', value: 3 },
  { name: '4 - string', value: 4 }
];

export const MEG_LEVEL = [0, 1, 2, 3, 4, 5, 6, 7];

export const DEFAULT_FLOWS = {
  flowId: 'Flow1',
  destinationMac: '',
  megLevel: 0,
  megId: '--',
  flowIdExist: false,
  attributes: {
    megLevel: 0,
    standard: 'ITU'
  },
  pm: {
    slmPeriod: 'off',
    slmDataTlvSize: 0,
    dmmPeriod: '1s',
    dmmDataTlvSize: 0
  },
  ccm: { ccmPeriod: 'off' }
};
